import ScalarFloating_vue_vue_type_script_setup_true_lang_default from "./ScalarFloating.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarFloating/ScalarFloating.vue
var ScalarFloating_default = ScalarFloating_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarFloating_default as default };

//# sourceMappingURL=ScalarFloating.vue.js.map